import React from 'react';
import styled from 'styled-components';
import { Icon } from '@amzn/storm-ui';
import { sparkle } from '@amzn/storm-ui-icons';

const StyledWrapper = styled('span')`
  position: relative;
`;

export function SalesAssistantIcon() {
  return (
    <StyledWrapper>
      <Icon type={sparkle} size="xlarge" />
    </StyledWrapper>
  );
}
